import Page from "./index";

export default { path: "/home/system/role", component: Page };
